<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" v-bind:href="'#t1'+rowData.simulador_id+''" role="tab" data-toggle="tab" >
                    <span class="nav-link-in">
                      Detalhes
                      <i class="fa fa-plus"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t2'+rowData.simulador_id+''" v-if="rowData.simulador_trecho.length>0" role="tab" data-toggle="tab" >
                    <span class="nav-link-in">
                      Trecho
                      <i class="fa fa-road"></i>
                    </span>
                  </a>
                </li>
			</ul>

            <div class="tab-content">
                <div role="tabpanel" class="tab-pane fade in active show" v-bind:id="'t1'+rowData.simulador_id+''">
                      <table class="table" id="mais">
                          <thead>
                              <tr>
                                  <th style="width: 15%">Descrição</th>
                                  <th style="width: 15%">Municipio de Início</th>
                                  <th style="width: 15%">Municipio de Fim</th>
                                  <th style="width: 10%">% Advalorem </th>
                              </tr>
                           </thead>
                           <tbody>
                               <tr class="bg-gray-light" style="display: table-row;">
                                  <td>
                                      {{ rowData.descr }}
                                  </td>
                                  <td>
                                      {{ rowData.municipio_inicio.nome }}
                                  </td>
                                  <td>
                                      {{ rowData.municipio_fim.nome }}
                                  </td>
                                  <td>
                                      {{ rowData.percentual_advalorem }} %
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                      <table class="table" id="mais">
                          <thead>
                              <tr>
                                  <th>Observação</th>
                              </tr>
                           </thead>
                           <tbody>
                               <tr class="bg-gray-light" style="display: table-row;">
                                   <td>
                                       <span v-if="rowData.obs!==null">
                                           {{ rowData.obs_simulador }}
                                       </span>
                                   </td>
                              </tr>
                          </tbody>
                      </table>
                  </div><!--.tab-pane-->
                  <div role="tabpanel" class="tab-pane fade" v-bind:id="'t2'+rowData.simulador_id+''">
                        <table class="table" id="mais">
                            <thead>
                                <tr>
                                    <th style="width: 5%">Ordem/Principal</th>
                                    <th style="width: 10%">Tipo Trecho</th>
                                    <th style="width: 15%">Tipo Custo</th>
                                    <th style="width: 15%">Modal</th>
                                    <th style="width: 13%">Município Início</th>
                                    <th style="width: 12%">Municipio Fim</th>
                                    <th style="width: 15%">Fornecedor</th>
                                    <th style="width: 5%">Status</th>
                                    <th style="width: 5%">Ações</th>
                                </tr>
                             </thead>
                             <tbody>
                               <template v-for="item in rowData.simulador_trecho">
                                 <tr class="bg-gray-light" style="display: table-row;">
                                    <td>
                                        {{ item.ordem }} - <span class="label label-success" v-if="item.principal.valor==1">{{ item.principal.descr }}</span>
                                                           <span class="label label-danger" v-if="item.principal.valor==2">{{ item.principal.descr }}</span>
                                    </td>
                                    <td>
                                        {{ item.tp_trecho.descr }}
                                    </td>
                                    <td>
                                      <span class="label label-success" v-if="item.tp_custo.valor==1">{{ item.tp_custo.descr }}</span>
                                      <span class="label label-danger" v-if="item.tp_custo.valor==2">{{ item.tp_custo.descr }}</span>
                                    </td>
                                    <td>
                                        {{ item.b_modal.descr }}
                                    </td>
                                    <td>
                                        {{ item.municipio_inicio.nome }}
                                    </td>
                                    <td>
                                        {{ item.municipio_fim.nome }}
                                    </td>
                                    <td v-if="item.fornecedor.pessoa_juridica!==null">
                                        {{ onFormataCnpj(item.fornecedor.pessoa_juridica.cnpj_base,item.fornecedor.pessoa_juridica.cnpj_filial,item.fornecedor.pessoa_juridica.cnpj_digito)}} - {{ item.fornecedor.pessoa_juridica.razao_social }}
                                    </td>
                                    <td  v-if="item.fornecedor.pessoa_fisica!==null">
                                        {{ item.fornecedor.pessoa_fisica.nome }} - {{ item.fornecedor.pessoa_fisica.cpf }}
                                    </td>
                                    <td  v-if="item.fornecedor.pessoa_exterior!==null">
                                        {{ item.fornecedor.pessoa_exterior.nome }} - {{ item.fornecedor.pessoa_exterior.cuit }}
                                    </td>
                                    <td>
                                      <span class="label label-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                      <span class="label label-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                    </td>
                                    <td>
                                      <a @click="onDetailTrecho(item)" v-if="item.simulador_trecho_custo.length>0" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                    </td>
                                </tr>
                                <tr v-if="isVisibleDetailRow(item.simtre_id)">
                                    <td colspan="9">
                                      <div class="tabs-section-nav">
                                        <div class="tbl">
                                          <ul class="nav" role="tablist">
                                            <li class="nav-item">
                                              <a class="nav-link active" v-bind:href="'#t1'+item.simtre_id+''" role="tab" data-toggle="tab" >
                                                <span class="nav-link-in">
                                                  Custos do Trecho
                                                  <i class="fa fa-bulding"></i>
                                                </span>
                                              </a>
                                            </li>
                                          </ul>
                                        </div>
                                      </div><!--.tabs-section-nav-->
                                      <div class="tab-content">
                                      <div role="tabpanel" class="tab-pane fade in active show" v-bind:id="'t1'+item.simtre_id+''">
                                        <table :class="['vuetable table table-striped tbl-typical']">
                                        <thead>
                                          <tr>
                                              <th style="width: 20%">Descrição</th>
                                              <th style="width: 20%">Tipo Custo</th>
                                              <th style="width: 20%">Custo</th>
                                              <th style="width: 20%">Valor</th>
                                              <th style="width: 20%">Status</th>
                                          </tr>
                                          </thead>
                                          <tbody  v-for="item_trecho_custo in item.simulador_trecho_custo">
                                              <tr class="bg-gray-light" style="display: table-row;">
                                                 <td v-if="item_trecho_custo.descr!==null">
                                                     {{ item_trecho_custo.descr }}
                                                 </td>
                                                 <td v-if="item_trecho_custo.tp_custo.descr!==null">
                                                     {{ item_trecho_custo.tp_custo.descr }}
                                                 </td>
                                                 <td v-if="item_trecho_custo.custo.descr!==null">
                                                     {{ item_trecho_custo.custo.descr }}
                                                 </td>
                                                 <td v-if="item_trecho_custo.vlr_custo!==null">
                                                     {{ item_trecho_custo.vlr_custo }}
                                                 </td>
                                                 <td>
                                                   <span class="label label-success" v-if="item_trecho_custo.status.valor==1">{{ item_trecho_custo.status.descr }}</span>
                                                   <span class="label label-danger" v-if="item_trecho_custo.status.valor==2">{{ item_trecho_custo.status.descr }}</span>
                                                 </td>
                                             </tr>
                                           </tbody>
                                        </table>
                                      </div>
                                    </div>
                                </td>
                              </tr>
                            </template>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
			</div><!--.tab-content-->
		</div>
    </div>
</template>

  <script>
import { formatCNPJFromParts } from "../utils";

  export default {
      data () {
        return {
          visibleDetailRows: [],
          visibleDetailRowsSimulador: [],
          helpForm: new Form({statusRecord: [], params: []}),
        }
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
      isVisibleDetailRow (rowId) {
        return this.visibleDetailRows.indexOf( rowId ) >= 0
      },
      showDetailRow (rowId) {
        if (!this.isVisibleDetailRow(rowId)) {
          this.visibleDetailRows.push(rowId)
        }
      },
      hideDetailRow (rowId) {
        if (this.isVisibleDetailRow(rowId)) {
          this.visibleDetailRows.splice(
            this.visibleDetailRows.indexOf(rowId),
            1
          )
        }
      },
      toggleDetailRow (rowId) {
        if (this.isVisibleDetailRow(rowId)) {
          this.hideDetailRow(rowId)
        } else {
          this.showDetailRow(rowId)
        }
      },
/////////////////////////////////////////////////////////////////////////////
      isVisibleDetailRowSimulador (rowId) {
        return this.visibleDetailRowsSimulador.indexOf( rowId ) >= 0
      },
      hideDetailRowSimulador (rowId) {
        if (!this.isVisibleDetailRowSimulador(rowId)) {
          this.visibleDetailRowsSimulador.push(rowId)
        }
      },
      hideDetailRowSimulador (rowId) {
        if (this.isVisibleDetailRowSimulador(rowId)) {
          this.visibleDetailRowsSimulador.splice(
            this.visibleDetailRowsSimulador.indexOf(rowId),
            1
          )
        }
      },
      toggleDetailRowSimulador (rowId) {
        if (this.isVisibleDetailRowSimulador(rowId)) {
          this.hideDetailRowSimulador(rowId)
        } else {
          this.hideDetailRowSimulador(rowId)
        }
      },
      onDetailTrecho(data) {
        this.toggleDetailRow(data.simtre_id);
      },
            onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
        return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
      },
  },
}
  </script>